import React from "react";
import { Card, CardContent, CardHeader } from "./ui/card";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Quote, Star } from "lucide-react";
import { mockData } from "../mock/mockData";

const TestimonialsSection = () => {
  const { testimonials } = mockData;

  const getInitials = (name) => {
    return name.split(' ').map(word => word[0]).join('').toUpperCase();
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star 
        key={index} 
        className={`w-4 h-4 ${
          index < rating ? 'text-[#FF6B35] fill-current' : 'text-gray-300'
        }`} 
      />
    ));
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#F6F6F6] via-white to-[#3E97FF]/5">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#252F4A] mb-6">
            Lo que dicen nuestros <span className="text-[#3E97FF]">Clientes</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#3E97FF] to-[#27AE60] mx-auto mb-6"></div>
          <p className="text-lg text-[#252F4A]/70 max-w-2xl mx-auto">
            La confianza de nuestros clientes es nuestro mayor logro. 
            Conoce sus experiencias trabajando con Infinitux Solutions.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id} 
              className="group hover:shadow-xl transition-all duration-500 border-0 bg-white/80 backdrop-blur-sm relative overflow-hidden"
            >
              {/* Quote decoration */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-12 h-12 text-[#3E97FF]" />
              </div>

              <CardHeader className="space-y-4 pb-4">
                {/* Rating */}
                <div className="flex items-center space-x-1">
                  {renderStars(testimonial.rating)}
                </div>

                {/* Content */}
                <CardContent className="p-0">
                  <blockquote className="text-[#252F4A]/80 leading-relaxed italic relative z-10">
                    "{testimonial.content}"
                  </blockquote>
                </CardContent>
              </CardHeader>

              <CardContent className="pt-6 border-t border-gray-100">
                <div className="flex items-center space-x-4">
                  {/* Avatar */}
                  <Avatar className="w-12 h-12 bg-gradient-to-br from-[#3E97FF] to-[#1C3C73]">
                    <AvatarFallback className="text-white font-semibold">
                      {getInitials(testimonial.name)}
                    </AvatarFallback>
                  </Avatar>

                  {/* Info */}
                  <div>
                    <div className="font-semibold text-[#252F4A] group-hover:text-[#3E97FF] transition-colors">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-[#252F4A]/70">
                      {testimonial.position}
                    </div>
                    <div className="text-sm text-[#3E97FF] font-medium">
                      {testimonial.company}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-[#3E97FF]/10">
            <h3 className="text-2xl font-bold text-[#252F4A] mb-4">
              ¿Listo para ser nuestro próximo caso de éxito?
            </h3>
            <p className="text-[#252F4A]/70 mb-6 max-w-2xl mx-auto">
              Únete a las empresas que ya están transformando sus procesos con nuestras soluciones.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: "smooth" })}
                className="bg-[#3E97FF] hover:bg-[#1C3C73] text-white px-8 py-3 rounded-lg transition-all duration-300 hover:shadow-lg"
              >
                Empezar Ahora
              </button>
              <button 
                onClick={() => document.getElementById('productos').scrollIntoView({ behavior: "smooth" })}
                className="border border-[#3E97FF] text-[#3E97FF] hover:bg-[#3E97FF] hover:text-white px-8 py-3 rounded-lg transition-all duration-300"
              >
                Ver Productos
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;